import React from 'react';
import { useParams } from 'react-router-dom';
import PageTabs from '../../../components/PageTabs';
import {
  Wallet,
  FileText,
} from '@phosphor-icons/react';

const FinanceTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();

  const tabs = [
    { key: 'expenses', label: 'Expenses', icon: Wallet, path: `/${slug}/owner/finance` },
    { key: 'reports', label: 'Reports', icon: FileText, path: `/${slug}/owner/finance/reports` },
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default FinanceTab;
